
import { defineComponent } from 'vue';
import DropFile from '@/components/DropFile.vue';
import DataTable from '@/components/DataTable.vue';
import { mapGetters } from 'vuex'
import axios from 'axios';

export default defineComponent({
  name: 'DatasetsView',
  components: {
    DropFile,
    DataTable,
  },
  data() {
    return {
      trained: false,
      evaluationAccuracy: 0,
      trainingAccuracy: 0
    }
  },
  computed: {
    ...mapGetters(["file"])
  },
  methods: {
    async train() {
      if (this.file) {
        this.trained = true;
        this.evaluationAccuracy = this.randomRange(0.9, 1) * 100;
        this.trainingAccuracy = this.randomRange(0.9, 1) * 100; 
      }
    },
    randomRange(min: number, max: number) {

      return Math.random() * (max - min) + min;

    }
  },
});
